export default __webpack_public_path__ + "static/media/img-0255-afghanistan-half-face.dc1e7c9e.png";